import { QuotesTableStaticActionType } from '../enums/quotesTableStaticActionType'
import type { QuotesTableStaticActionItem } from '../types/quotesTableStaticActionItem'

interface GetEffectiveQuotesTableItemsOptions {
  isDownloading: boolean
  isProcessing: boolean
  isProcessingSendAsEmail: boolean
}

const actionTypesDisabledWhileProcessing = [
  QuotesTableStaticActionType.MarkAsSent,
  QuotesTableStaticActionType.MarkAsUnsent,
  QuotesTableStaticActionType.ChangeStatus,
]

export const getEffectiveQuotesTableItems = (
  items: QuotesTableStaticActionItem[],
  { isDownloading, isProcessing, isProcessingSendAsEmail }: GetEffectiveQuotesTableItemsOptions,
): QuotesTableStaticActionItem[] => {
  if (!isDownloading && !isProcessing && !isProcessingSendAsEmail) {
    return items
  }

  return items.map((item) => {
    const itemId = item.id
    const isReadonly =
      (itemId === QuotesTableStaticActionType.Download && isDownloading) ||
      (actionTypesDisabledWhileProcessing.includes(itemId as QuotesTableStaticActionType) && isProcessing) ||
      (itemId === QuotesTableStaticActionType.SendByEmail && isProcessingSendAsEmail)

    return isReadonly
      ? {
          ...item,
          readonly: true,
          ...(item.subItems ? { subItems: item.subItems.map((sub) => ({ ...sub, readonly: true })) } : {}),
        }
      : item
  })
}
